import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { SpammerNodeView } from '../../components/extensions/SpammerNodeView';

const Spammer = Node.create({
  name: 'spammer',

  priority: 101,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  group: 'inline',

  inline: true,

  selectable: false,

  atom: true,

  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-target'),
        renderHTML: (attributes) => {
          if (!attributes.id) {
            return {};
          }

          return {
            'data-target': attributes.id,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: `entity[data-type="${this.name}"]`,
        getAttrs: (element) => {
          const id = element.getAttribute('data-target');
          return id ? { id } : false;
        },
      },
      {
        tag: `span[data-type="${this.name}"]`,
        getAttrs: (element) => {
          const id = element.getAttribute('data-target');
          return id ? { id } : false;
        },
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    const attrs = mergeAttributes(
      {
        'data-type': this.name,
        'data-target': node.attrs.id,
      },
      this.options.HTMLAttributes,
      HTMLAttributes,
    );

    return ['entity', attrs];
  },

  addNodeView() {
    return ReactNodeViewRenderer(SpammerNodeView);
  },

  addKeyboardShortcuts() {
    return {
      Backspace: () =>
        this.editor.commands.command(({ tr, state }) => {
          let isSpammer = false;
          const { selection } = state;
          const { empty, anchor } = selection;

          if (!empty) {
            return false;
          }

          state.doc.nodesBetween(anchor - 1, anchor, (node, pos) => {
            if (node.type.name === this.name) {
              isSpammer = true;
              tr.insertText('', pos, pos + node.nodeSize);

              return false;
            }
          });

          return isSpammer;
        }),
    };
  },
});

export default Spammer;
